import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
// Mantine styles MUST be imported before our component styles so our own
// `*.module.css` overrides win the cascade. The provider carries the bridge
// theme (src/theme.ts, 2026-07-21) that unifies Mantine components with the
// tokens.css design system — accent, radii, type scale, component defaults.
import "@mantine/core/styles.css";
import "@mantine/notifications/styles.css";
import { MantineProvider } from "@mantine/core";
import { Notifications } from "@mantine/notifications";
import { ModalsProvider } from "@mantine/modals";
import { App } from "./App";
import { theme } from "./theme";
import "./styles/global.css";

// Sensible client-wide query defaults: don't hammer the API on window focus,
// and treat data as fresh for a short window so navigations feel instant.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 15_000,
    },
  },
});

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element #root not found");
}

createRoot(rootElement).render(
  <StrictMode>
    <MantineProvider theme={theme} defaultColorScheme="light">
      <Notifications />
      <ModalsProvider>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </ModalsProvider>
    </MantineProvider>
  </StrictMode>,
);
